<template>
  <custom-modal
    title="Call menu"
    :on-save="
      () => {
        onSave(selectedNumbers);
      }
    "
    :on-cancel="onCancel"
    custom-style="width: 570px; height: 355px;"
    content-style="padding: 0 40px;"
    :disabled="false"
  >
    <div class="description" style="margin-top: 30px;">
      Choose numpad buttons you want to use for your IVR menu.
    </div>
    <div class="description">
      After that you’ll have an option to choose function for each line.
    </div>
    <div class="buttons-container">
      <div
        v-for="(item, index) in numbers"
        :key="index"
        class="call-menu-button"
        :class="{
          'bordered': index !== 9,
          'selected': selectedNumbers.includes(item)
        }"
        @click="onSelect(item)"
      >
        <span class="button-number">{{ item }}</span>
        <span class="button-text">{{ numberText(item) }}</span>
      </div>
    </div>
    <div class="description-grey" style="margin-top: 25px;">
      For creating IVR menu choose at least two lines.
    </div>
    <div class="description-grey">
      #0 is great for Repeat function.
    </div>
  </custom-modal>
</template>

<script>
import CustomModal from '@/components/CustomModal';
import { convertNumberToCharacter } from '@/utils';

export default {
  name: 'CallMenuModal',
  components: { CustomModal },
  props: {
    onSave: Function,
    onCancel: Function,
    callMenuNumbers: Array
  },
  data() {
    return {
      selectedNumbers: []
    };
  },
  computed: {
    numbers() {
      const ns = [];
      for (let i = 1; i < 10; i++) {
        ns.push(i);
      }
      ns.push(0);
      return ns;
    }
  },
  mounted() {
    if (this.callMenuNumbers && this.callMenuNumbers.length > 0) {
      this.selectedNumbers = [...this.callMenuNumbers];
    }
  },
  methods: {
    numberText(num) {
      return convertNumberToCharacter(num);
    },

    onSelect(item) {
      if (this.selectedNumbers.includes(item)) {
        this.selectedNumbers.splice(this.selectedNumbers.indexOf(item), 1);
      } else {
        this.selectedNumbers.push(item);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.description {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: #374561;
}

.buttons-container {
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  border: 1px solid #dfe1e5;
  border-radius: 4px;

  .call-menu-button {
    flex: 1;
    height: 49px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    background-color: #ffffff;

    &.bordered {
      border-right: 1px solid #dfe1e5;
    }

    &.selected {
      background-color: $colorBack;
    }

    .button-number {
      font-size: 20px;
      line-height: 25px;
      text-align: center;
      letter-spacing: -0.02em;
      color: $colorText;
      margin-top: 4px;
    }

    .button-text {
      font-weight: 500;
      font-size: 6px;
      line-height: 16px;
      text-align: center;
      letter-spacing: 0.2em;
      color: $colorText;
    }
  }
}

.description-grey {
  font-size: 12px;
  line-height: 18px;
  letter-spacing: -0.01em;
  color: $colorPlaceholder;
}

.error-message {
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: $colorRed;
  margin-top: 10px;
}
</style>
